(function () {
  function getRoot() {
    return document.querySelector('.wt-product__main') || document;
  }

  function getMainProductForm(root) {
    // Nimm das "richtige" Product-Form, nicht installment / nicht quick-add
    var forms = Array.from(root.querySelectorAll('form[action^="/cart/add"], form[action*="/cart/add"]'));

    // bevorzugt: id beginnt mit product-form- und enthält NICHT installment
    var preferred = forms.find(function (f) {
      var id = (f.getAttribute('id') || '');
      return id.startsWith('product-form-') && !id.includes('installment');
    });
    if (preferred) return preferred;

    // fallback: irgendein form mit input[name="id"]
    var fallback = forms.find(function (f) {
      return !!f.querySelector('input[name="id"]');
    });

    return fallback || null;
  }

  function getVariantId(root) {
    var form = getMainProductForm(root);
    if (!form) return null;

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return null;

    return String(idInput.value);
  }

  function getSpecsMap() {
    if (!window.__variantSpecs) return null;
    var keys = Object.keys(window.__variantSpecs);
    if (!keys.length) return null;
    return window.__variantSpecs[keys[0]]; // 1 Produktseite -> reicht
  }

  function setRowValue(root, key, value) {
    var row = root.querySelector('[data-spec-row="' + key + '"]');
    var span = root.querySelector('[data-spec-value="' + key + '"]');

    if (!row || !span) return;

    if (value === null || value === "" || typeof value === "undefined") {
      row.style.display = "none";
      return;
    }

    row.style.display = "";
    span.textContent = value;
  }

  function updateVariantSpecs() {
    var root = getRoot();
    var variantId = getVariantId(root);
    if (!variantId) return;

    var specsMap = getSpecsMap();
    if (!specsMap || !specsMap[variantId]) return;

    var data = specsMap[variantId];

    setRowValue(root, "width_cm", data.width_cm);
    setRowValue(root, "length_cm", data.length_cm);
    setRowValue(root, "total_weight_kg", data.total_weight_kg);
  }

  // Initial
  document.addEventListener('DOMContentLoaded', function () {
    updateVariantSpecs();
  });

  // Variant-Auswahl (Select/Swatches)
  document.addEventListener('change', function (e) {
    var root = getRoot();
    if (!root.contains(e.target)) return;
    setTimeout(updateVariantSpecs, 80);
  });

  // Falls das Theme ein Event feuert
  document.addEventListener('variant:change', function () {
    setTimeout(updateVariantSpecs, 0);
  });

  // Sehr robust: wenn Theme DOM umschreibt
  var obs;
  document.addEventListener('DOMContentLoaded', function () {
    var root = getRoot();
    if (!root || root === document) return;

    obs = new MutationObserver(function () {
      clearTimeout(window.__specUpdateTimer);
      window.__specUpdateTimer = setTimeout(updateVariantSpecs, 120);
    });

    obs.observe(root, { childList: true, subtree: true });
  });
})();

document.addEventListener('DOMContentLoaded', function () {

  const faqs = document.querySelectorAll('.dc-faq__accordion');

  faqs.forEach(function(accordion){

    const items = accordion.querySelectorAll('details');

    items.forEach(function(item){

      item.addEventListener('toggle', function(){

        if(item.open){

          items.forEach(function(other){

            if(other !== item){
              other.removeAttribute('open');
            }

          });

        }

      });

    });

  });

});